import {Injectable, Injector} from "@angular/core";
import {SpecialScheduleData} from "./special-schedule.data";
import {PricingScheduleEntityModel} from "../pricing-schedule/pricing-schedule-entity.model";

@Injectable()
export class SpecialScheduleEntityModel extends PricingScheduleEntityModel<SpecialScheduleData> {
    constructor(injector: Injector) {
        super(injector, SpecialScheduleData);
    }

    protected override onBeforeSaveEntity(entityData: SpecialScheduleData) {
        super.onBeforeSaveEntity(entityData);
        entityData.allTerminals = !entityData.terminals.length;
    }
}
